import { render } from "./selectProductImgChannel.vue?vue&type=template&id=701dde34"
import script from "./selectProductImgChannel.vue?vue&type=script&lang=js"
export * from "./selectProductImgChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/product/components/selectProductImgChannel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "701dde34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('701dde34', __exports__)) {
    api.reload('701dde34', __exports__)
  }
  
  module.hot.accept("./selectProductImgChannel.vue?vue&type=template&id=701dde34", () => {
    api.rerender('701dde34', render)
  })

}


export default __exports__